import { Stack, Switch, Typography } from "@mui/material";
import React from "react";

const SwitchComponent = ({ leftLabel = "", rightLabel = "", ...props }) => {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Typography>{leftLabel}</Typography>
      <Switch {...props} />
      <Typography>{rightLabel}</Typography>
    </Stack>
  );
};

export default SwitchComponent;
